import Amplify from '@aws-amplify/core';
import UchainAxios from "@mobile-dev/platform/common/api/UchainAxios.js";
import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { PersistGate } from 'redux-persist/integration/react';
import App from './App';
import awsmobile from './aws-exports';
// import DevTools from './redux.devtools';
import configureStore from './store';
import './styles/floating-labels.css';
import './styles/image-styles.css';
import Wrapper from './Utils/Wrapper';

Amplify.configure(awsmobile);
const { store, persistor } = configureStore();

// const devTools = process.env.NODE_ENV !== 'production' ? <DevTools /> : null;

const appTemplate = (
  <Wrapper>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
        {/* {devTools} */}
      </PersistGate>
    </Provider >
  </Wrapper>);


ReactDOM.render(appTemplate, document.getElementById('uchainRootApp'));

//for MAC refresh token
window.addEventListener("unhandledrejection", function (e) {
  if (e.reason?.code === "NotAuthorizedException" || e.reason === "No current user") {
    store.dispatch({ type: 'USER_LOGOUT' })
    alert("session expired!!");
  }
});

UchainAxios.interceptors.response.use(response => {
  return response;
}, error => {
  if (error?.response?.status === 401 || error?.response?.status === 403) {
    store.dispatch({ type: 'USER_LOGOUT' })
    alert("session expired!!");
  }
  return Promise.reject(error);
});